module.exports = __webpack_public_path__ + "img/cropped-K_entradas_hor_cas.d008a72b.jpg";